<template>
  <div :class="clContainer()">
    <spinner v-if="isLoading"></spinner>

    <ul v-else-if="data.length" :class="clSub('list', 'list-reset')">
      <li v-if="showFilter" class="bg-transparent">
        <div :class="'bg-transparent ' + clSub('list-item ')">
          <label :class="clSub('label', 'pull-right')">
            Abschlüsse einblenden
            <input
              type="checkbox"
              :class="clSub('input', 'form__input')"
              @input="filterChange()"
              spellcheck="false"
            />
          </label>
        </div>
      </li>
      <li v-for="(message, index) in data" :key="message.id">
        <div
        v-if="message.type != 1 || showMontage"
          :class="
            clSub('list-item' + (isSelected(message) ? ' is-selected' : '')) +
            ' ' +
            clSub(message.type != 1 || showMontage ? '' : 'hidde_desc')
          "
        >
          <slot
            name="message"
            :message="message"
            :index="index"
            :isSelected="isSelected(message)"
          >
            <message
              :message="message"
              :index="index"
              :is-selected="isSelected(message)"
              :base-class="clSub('message')"
            ></message>
          </slot>
        </div>
      </li>
    </ul>

    <div
      v-else-if="noDataMessage"
      v-html="noDataMessage"
      :class="clSub('no-data')"
    ></div>
  </div>
</template>

<script>
import LoadsData from "../Mixins/LoadsData";
import NeedsSetableCssClasses from "../Mixins/NeedsSetableCssClasses";
import Message from "./Message";

export default {
  mixins: [LoadsData, NeedsSetableCssClasses],
  components: { message: Message },
  props: {
    baseClass: {
      type: String,
      default: "messages",
    },
    noDataMessage: {
      type: String,
    },
    showFilter: {
      type: Boolean,
      default: true,
    },
    selectedMessage: {
      type: Object,
    },
  },
  data() {
    return {
      showMontage: false,
    };
  },
  methods: {
    isSelected(message) {
      if (this.selectedMessage) {
        return Object.keys(this.selectedMessage).every((key) => {
          return key in message && message[key] == this.selectedMessage[key];
        });
      }

      return false;
    },
    filterChange() {
      this.showMontage = !this.showMontage;
    },
  },
};
</script>
<style scoped>
.bg-transparent {
  background: transparent;
}
.job-messages__label,
.messages-jobs__label {
  display: flex;
  white-space: nowrap;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.job-messages__label input,
.messages-jobs__label input {
  width: 12px;
  margin-left: 8px;
}

.messages-jobs__list-item.bg-transparent {
  padding-right: 0;
}
</style>